__webpack_require__.p = "/offersngrx/referrals/";